import { memo, useContext } from 'react';
import { shallowEqual } from 'react-redux';

import { Spacer } from '@zillow/constellation';
import { TextButton } from '@zillow/constellation-10';
import { LoadingText } from '@zg-rentals/loading-components';
import { useRentalManagerUserPropertyWebAnalyticsWebApiHandler_get } from '@zg-rentals/rental-manager-env';

import { useSelector } from '../../../../selectors/useSelector';
import { LoadingMapContext } from '../../../../providers/LoadingMapContext/context';
import DashboardCSEvents from '../../../../model/ClickstreamEvent/DashboardCSEvents';

const HELP_CENTER_ARTICLE =
  'https://zillow.zendesk.com/hc/en-us/articles/32837812512531-Managing-Your-Listings#h_01JKGQ7G1DQ969C3KFAPHYNQDW';

const WhenListingExpireLearnMore = () => {
  const { listingAlias, user } = useSelector(
    (state) => ({ user: state.user, listingAlias: state.properties.currentProperty.listingAlias }),
    shallowEqual,
  );
  const {
    loadingByComponent: { ListingModule: isListingModuleLoading },
  } = useContext(LoadingMapContext);

  const { data: webAnalyticsDatWithLease } = useRentalManagerUserPropertyWebAnalyticsWebApiHandler_get(
    {
      listingAlias,
      includeLeases: true,
    },
    {
      enabled: Boolean(listingAlias),
    },
  );

  return (
    <Spacer marginTop="xs">
      <LoadingText textStyle="body-sm-bold" isLoading={isListingModuleLoading} loadingWidth="80%">
        When will my listing expire?{' '}
        <TextButton
          textStyle="body-sm-bold"
          asChild
          onClick={() => {
            if (webAnalyticsDatWithLease) {
              const { lease, ...webAnalyticsData } = webAnalyticsDatWithLease;

              DashboardCSEvents.WhenListingExpireLearnMoreClick({
                lease,
                currentProperty: webAnalyticsData ?? {},
                user,
              });
            }
          }}
          data-eventid={DashboardCSEvents.WhenListingExpireLearnMoreClick.data_event_id}
        >
          <a target="_blank" href={HELP_CENTER_ARTICLE} rel="noreferrer">
            Learn more
          </a>
        </TextButton>
      </LoadingText>
    </Spacer>
  );
};

export default memo(WhenListingExpireLearnMore);
